<template>
  <div class="download-pdf">
    <span class="title">{{ $t('hose.dimensions') }}</span>
    <div class="download-button" @click="downloadPdf">
      <img :src="getImage('hose/Pdf-file.svg')">
      <span class="text">{{ $t('hose.download') }}</span>
    </div>
  </div>
</template>

<script>
import {AxiosDefault} from "@/mixins/AxiosWrapperMixin";
import FileDownload from "js-file-download";
import {mapActions, mapGetters, mapState} from "vuex";
import Swal from "sweetalert2";

export default {
  name: "PdfDownloader",

  computed: {
    ...mapGetters({
      mode: 'preference/getMode',
      isMagento: 'preference/isMagento',
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },

  methods: {
    ...mapActions({
      redirectToLoginUrl: 'auth/redirectToLoginUrl',
    }),

    async downloadPdf() {
      if (!this.isLoggedIn) {
        Swal.fire({
          title: this.$t('auth.login.loginRequired'),
          text: this.$t('auth.login.loginRequiredText'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('auth.login.loginButton'),
          cancelButtonText: this.$t('auth.login.cancelButton'),
        }).then((result) => {
          if (result.value) {
            this.redirectToLoginUrl();
          }
        });

        return;
      }

      const canvas = document.getElementById('hose-canvas');
      const render = canvas.toDataURL();
      const buildLink = await this.$store.dispatch('build/hoses/getBuildId');

      let magentoGenerator = '/slang-configurator';
      if (this.isMagento) {
        magentoGenerator = window.location.pathname;
      }

      AxiosDefault.post('hose/pdf', {
        build: {...this.$store.getters["build/hoses/getBuildObject"], buildLink},
        mode: this.mode,
        magentoGenerator: window.location.pathname,
        render,
      }, {
        responseType: 'blob',
      })
          .then((response) => {
            FileDownload(response.data, 'slang.pdf');
            this.$emit('close');

            // console.log('image', image, response.data);
            //  `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;

            // this.img = data.url;
            // this.id = data.id;
            // this.download()
          })
          .catch((e) => {
            console.log(e);
            this.error = true;
          });
    }
  }

}
</script>

<style scoped lang="scss">
.download-pdf {
  color: #3C3C3B;
  grid-row-start: 1;
  grid-row-end: 2;

  .title {
    font-family: neue-haas-grotesk-display, sans-serif;
    font-size: 14px;
  }

  .download-button {
    font-family: neue-haas-grotesk-text, sans-serif;
    font-size: 12px;
    margin-top: 4px;
    max-width: 90px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .text {
      display: block;
      margin-left: 6px;
      line-height: 1.1;
    }
  }
}
</style>
